import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import Bundle from '@saucelabs/sl-component-bundle';
import { NotFound } from '@saucelabs/sl-component-error-pages';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import analyticsReducer from './reducers';
import { CLOUD_TYPE_PARAM_NAME, TEST_HISTORY_PATH, TEST_OVERVIEW_PATH } from './constants';

const importFailureAnalysis = () => import(/* webpackChunkName: "an-failure-analysis" */ './containers/FailureAnalysisContainer');
const importFlatConcurrency = () => import(/* webpackChunkName: "an-flat-concurrency" */ './containers/FlatVmConcurrencyContainer');
const importFlatTrends = () => import(/* webpackChunkName: "an-flat-trends" */ './containers/FlatTrendsContainer');
const TestHistoryContainer = () => import(/* webpackChunkName: "an-test-history" */ './containers/TestHistoryContainer');
const importTestOverview = () => import(/* webpackChunkName: "an-test-overview" */ './containers/TestOverviewContainer');
const importCoverage = () => import(/* webpackChunkName: "an-test-overview" */ './containers/CoverageContainer');

const AnalyticsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.PERFORMANCE}>
      <Switch>
        <Route
          path={`${match.url}${TEST_HISTORY_PATH}`}
          render={(props) => (
            <Bundle load={TestHistoryContainer}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          )}
        />
        <Route
          path={`${match.url}/test-patterns/:tabName?/:rootCauseId?`}
          render={(props) => (
            <Bundle load={importFailureAnalysis}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          )}
        />
        <Route
          path={`${match.url}${TEST_OVERVIEW_PATH}`}
          render={(props) => (
            <Bundle
              load={importTestOverview}
            >
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          )}
        />
        <BundleRoute
          load={importFlatConcurrency}
          path={`${match.url}/trends/concurrency`}
        />
        <BundleRoute
          load={importFlatTrends}
          path={`${match.url}/trends/:${CLOUD_TYPE_PARAM_NAME}?`}
        />
        <Route
          path={`${match.url}/coverage/:tabName?/:${CLOUD_TYPE_PARAM_NAME}?`}
          render={(props) => (
            <Bundle load={importCoverage}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          )}
        />
        <Route component={NotFound} />
      </Switch>
    </SentryBoundary>
  </LoginRequiredContainer>
);
AnalyticsRoutes.propTypes = {
  location: PropTypes.any.isRequired,
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.analytics',
  attachReducer(analyticsReducer),
)(AnalyticsRoutes);
